import { ClosedEyeIcon } from "frontend/icons/closed-eye-icon";
import { OpenedEyeIcon } from "frontend/icons/opened-eye-icon";
import style from "./frameVisiblePicker.module.css";
import ToggleButton from "./toggle-button";

export default function VisiblePicker({ value, onChange }: { value?: boolean; onChange: (visible: boolean) => void }) {
  value = value ?? true;

  return (
    <>
      <div className={style.container} data-testid="FrameVisible">
        <ToggleButton
          tooltip={value ? "Hide Frame" : "Show Frame"}
          isOn={true}
          onClick={() => {
            onChange(!value);
          }}
          className={style.button}
        >
          {value ? <OpenedEyeIcon /> : <ClosedEyeIcon />}
        </ToggleButton>
      </div>
    </>
  );
}
